export default "__VITE_PUBLIC_ASSET__70823696__"